import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'
import { useCollections } from 'hooks/menu-collections'

export function useTracking({ menuId }: { menuId: string }) {
  const dispatch = useDispatch()
  const collections = useCollections()

  return useCallback(() => {
    const collectionSlugs = collections.map((collection) => collection.slug)
    const collectionPositions = collectionSlugs.map((_, index) => index + 1)

    dispatch({
      type: actionTypes.COLLECTION_NAV_SHOWN,
      trackingData: {
        actionType: trackingKeys.collectionNavShown,
        collectionNamesArray: collectionSlugs,
        collectionPositionsArray: collectionPositions,
        menuId,
      },
    })
  }, [dispatch, collections, menuId])
}
